export enum SettlementPage {
    //which page should view: 1 for invoices, 2 for doctor fees
    InvoicesPage = 1,
    DoctorFeesPage = 2,
}